/*
 * The document's typed translator: core's accessor over the `doc` namespace, so a key that is not
 * in `en` and a missing placeholder are both compile errors wherever the document draws a word.
 *
 * The catalogue is imported as a *type*. Its text arrives with the document's chunk, which
 * registers it under `doc` before the first document renders; importing `en` as a value here
 * would pull the whole document copy into every chunk that imports this file.
 */

import { namespaceT } from "../../i18n/index.ts"
import type { ArgsOf } from "../../i18n/t.ts"
import type { en } from "./en.ts"

export type DocCatalogue = typeof en
export type DocKey = keyof DocCatalogue
export type DocArgs<K extends DocKey> = ArgsOf<DocCatalogue, K>

/** The namespace the document's catalogue is registered under (`addCatalogue`). */
export const DOC_NAMESPACE = "doc"

/** The text of one document key, with its placeholders filled in. */
export const t = namespaceT<DocCatalogue>(DOC_NAMESPACE)
